export default __webpack_public_path__ + "16154d45f5b7df76ba2c20d3c196ab8c.svg";